var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1621 3.73893L14.0117 2.88929C15.4195 1.48156 17.7018 1.48156 19.1096 2.88929C20.5173 4.29702 20.5173 6.5794 19.1096 7.98713L18.2599 8.83677M13.1621 3.73893C13.1621 3.73893 13.2683 5.54442 14.8614 7.13749C16.4544 8.73056 18.2599 8.83677 18.2599 8.83677M13.1621 3.73893L5.35095 11.5501C4.82189 12.0791 4.55735 12.3437 4.32985 12.6353C4.06149 12.9794 3.83141 13.3517 3.64368 13.7456C3.48454 14.0795 3.36623 14.4344 3.12963 15.1442L2.12702 18.1521M18.2599 8.83677L10.4488 16.6479C9.91972 17.177 9.65519 17.4415 9.36351 17.669C9.01945 17.9374 8.64716 18.1675 8.25326 18.3552C7.91933 18.5143 7.56443 18.6326 6.85461 18.8692L3.84679 19.8718M3.84679 19.8718L3.11155 20.1169C2.76225 20.2334 2.37713 20.1424 2.11678 19.8821C1.85642 19.6217 1.76551 19.2366 1.88194 18.8873L2.12702 18.1521M3.84679 19.8718L2.12702 18.1521",
    stroke: "#4E536E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.2e9bed9d49ca16e7c41801bfab337bec.svg";
export { ForwardRef as ReactComponent };